import { useState, FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { Lock, User, AlertCircle, Activity } from 'lucide-react'
import { useAuthStore } from '../hooks/useAuthStore'

export default function Login() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const { login, loginError, loading } = useAuthStore()
  const navigate = useNavigate()

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    const success = await login(username, password)
    if (success) {
      navigate('/', { replace: true })
    }
  }

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        {/* Logo / Title */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-blue-500/10 border border-blue-500/20 mb-4">
            <Activity size={24} className="text-blue-400" />
          </div>
          <h1 className="text-2xl font-bold text-white">FirstLight</h1>
          <p className="text-sm text-[#666] mt-1">Trading Dashboard</p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="bg-[#111] border border-[#222] rounded-xl p-6 space-y-4">
            {/* Error message */}
            {loginError && (
              <div className="flex items-center gap-2 p-3 bg-red-500/10 border border-red-500/20 rounded-lg">
                <AlertCircle size={16} className="text-red-400 flex-shrink-0" />
                <span className="text-sm text-red-400">{loginError}</span>
              </div>
            )}

            {/* Username */}
            <div>
              <label className="flex items-center gap-1.5 text-xs text-[#666] font-medium mb-1.5 uppercase tracking-wider">
                <User size={14} className="text-[#555]" />
                Username
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="input w-full"
                placeholder="Enter username"
                autoComplete="username"
                autoFocus
                required
              />
            </div>

            {/* Password */}
            <div>
              <label className="flex items-center gap-1.5 text-xs text-[#666] font-medium mb-1.5 uppercase tracking-wider">
                <Lock size={14} className="text-[#555]" />
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input w-full"
                placeholder="Enter password"
                autoComplete="current-password"
                required
              />
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading || !username || !password}
              className="btn btn-primary w-full flex items-center justify-center gap-2 mt-2"
            >
              {loading ? (
                <>
                  <Activity size={16} className="animate-spin" />
                  Signing in...
                </>
              ) : (
                <>
                  <Lock size={16} />
                  Sign In
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
